// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.is-invalid[data-v-5d567869] { color: red\n}\n.is-invalid a[data-v-5d567869] { color: brown\n}\n", ""]);
// Exports
module.exports = exports;
